var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"download-btn",attrs:{"disabled":!_vm.$store.state.isAuthorized},on:{"click":_vm.download}},[_c('font-awesome-icon',{attrs:{"icon":"download"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }